<template>
	<div>
		<!-- <div class="textCenter" v-if="isLoading">
              <Loading  :isLoading="true" ></Loading>
        </div> -->
	    <div class="main-container hotel-container" >
            <div class="rule">
            	<ul class="step">
    				<li class="step-arrow "></li>
        			<li class="step-text ">填写订单</li>
        			<li class="step-arrow active"></li>
        			<li class="step-text active">订单支付</li>
        			<li class="step-arrow active"></li>
        			<li class="step-text active ">订单完成</li>
    			</ul>
    			<div class="back-btn-a" @click="returnBack">← 返回</div>
                <div class="main-left fill-order">
                    <div class="title" id="floatTop">{{Detail.Type==1?'预定信息':'抢购信息'}}</div>
                    <div class="content" >
                        <div class="content-item-a" v-if="Detail.Type==1">
                            <label class="item-title">出发日期</label>
                            <div class="item-body">
                                <p class="time">{{PackageBookInfo.HandleItem.Date}}</p>
                            </div>
                        </div>
                        <div class="content-item-a" v-else>
                            <label class="item-title">有效期至</label>
                            <div class="item-body">
                                <p class="time">{{Detail.BookingEnd|dateToYMDline}}</p>
                            </div>
                        </div>
                        <div class="content-item-a">
                            <label class="item-title">选择数量</label>
                            <div class="item-body">
                                <div class="compute">
                                    <span class="btn" @click="minus">-</span>
                                    <span class="count">{{stock}}</span>
                                    <span class="btn" @click="plus">+</span>
                                </div>
                                <!-- <div>
                                    <div class="select-box">
                                        <select v-model="bookInfo.RoomCount" @change="upgrade">
                                            <option :value="index+1" v-for="(rc,index) in RoomCountList">{{index+1}}</option>
                                        </select>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <div class="content-item-a">
                            <label class="item-title">套餐单价</label>
                            <div class="item-body">
                                <span class="price">{{Currency}}  {{PackageBookInfo.HandleItem.Price}}  /份</span>
                            </div>
                        </div>

                        <div class="content-item-a" v-if="Detail.Type==1">
                            <label class="item-title">填写信息</label>
                            <div :class="index>0?'room-mg item-body':'item-body'" v-for="G,index in Groups"> 
                                <div class="item-room-num">旅客 {{Groups.length>1?index+1:''}}</div>
                                <div>
                                    <div class="input-box">
                                        <input type="text" maxlength="50" placeholder="姓名" v-model="G.CnName" >
                                        <i class="iconfont icon-guanbi user-close-btn" @click="G.CnName=''" v-if="G.CnName"></i>
                                    </div>
                                </div>
                                <div class="input-box" v-if="PackageBookInfo.IsIdcard">
                                    <input type="text" maxlength="50" placeholder="身份证号" v-model="G.CardNumber" >
                                    <i class="iconfont icon-guanbi user-close-btn" @click="G.CardNumber=''" v-if="G.CardNumber"></i>
                                </div>
                            </div>
                        </div>

                        <div class="content-item-a">
                            <label class="item-title">手机号码</label>
                            <div class='item-body'> 
                                <div class="input-box">
                                    <input type="tel" maxlength="50" placeholder="为您更好地服务" v-model="Phone" >
                                    <i class="iconfont icon-guanbi user-close-btn" @click="Phone=''" v-if="Phone"></i>
                                </div>
                            </div>
                        </div>

                        <div class="content-item-a" v-if="Detail.Type==1">
                            <label class="item-title">特殊要求</label>
                            <div class='item-body'> 
                                <div class="input-box" style="width: 400px;">
                                    <textarea type="text"  placeholder="描述" v-model="SpecialRequest" ></textarea>
                                </div>
                            </div>
                        </div>

                        <div v-for="N,index in Detail.Notice" :key="index" v-if="index=='购买须知'">
                            <div class="title">{{index}}</div>
                            <div class="content" v-html="N"></div>
                        </div>

                        <div class="title">关于发票</div>
                        <div v-for="N,index in Detail.Notice" :key="index" v-if="index=='发票说明'">
                          <div class="content" v-html="N"></div>
                        </div>
                        <div class="content" v-if="!Detail.Notice||!Detail.Notice.发票说明"><p>★发票由我方开具，支持电子普通发票。<br/>★开具发票请提供准确的开票信息，电子普通发票请提供准确邮箱，不提供增值税专用发票。</p></div>

                        <div class="content">
                          <!-- <div v-if="details.Type==2" class="hanleDate">
                            产品支持预约前 <span style="font-size: 0.24rem;color: #fb8801;display: inline-block;padding: 3px;background: #fff6eb;"> 随时退 </span> ，过期未预约 <span style="font-size: 0.24rem;color: #fb8801;display: inline-block;padding: 3px;background: #fff6eb;"> 全额退 </span>。
                          </div> -->
                            <label>
                            	<p class="info">
                            		<input type="checkbox" v-model="isAgree"/>
                                我已阅读并同意，此订单
                            		<span v-if="PackageBookInfo.HandleItem.AllowCancel==false&&Detail.Type==1">即订即保，订单一经确认，不可取消、更改</span>
                                <span v-if="PackageBookInfo.HandleItem.AllowCancel&&Detail.Type==1&&PackageBookInfo.HandleItem.CancelDate" class="hanleDate">最后可取消时间为：{{PackageBookInfo.HandleItem.CancelDate}}</span>
                                <span v-if="Detail.Type==2">
                                  <span>{{PackageBookInfo.ReserveDay>0?'至少提前'+PackageBookInfo.ReserveDay+'天预约，':(PackageBookInfo.ReserveHour=='23:59'?'':'需当日'+PackageBookInfo.ReserveHour+'前预定， ')}}</span>有效期至 <span style="font-weight: bold;">{{Detail.BookingEnd|dateToYMDline}}</span>
                                </span>
                                (最终解释权归订房易所有)
                            	</p>
                            </label>
                        </div>
                        <div class="btn-group" id="stopScroll">
                            <div class="submit-btn" @click="checkBookAble">提交订单</div>
                            <div class="re-select-btn"  @click="returnBack">重新选择套餐</div>
                        </div>
                    </div>
                </div>
                <div  class='main-right' :style="{top:scroll+'px'}" id="mapandhsbox">
                    <div class="right-content">
                        <a class="hotel-name" href="javascript:void(0)">
                        	{{PackageBookInfo.ProductName}}
                        </a>
                        <p class="ps">{{PackageBookInfo.SkuName}}</p>
                        <div v-if="PackageBookInfo&&PackageBookInfo.SkuPieces">
                            <p class="room-name">产品包含</p>
                            <p class="info" v-for="S in PackageBookInfo.SkuPieces" v-if="S">{{S}}</p>
                        </div>
                        <div class="tip">
                            <span v-if="PackageBookInfo.HandleItem.AllowCancel==false&&Detail.Type==1">不可取消 </span>
                            <span v-if="PackageBookInfo.HandleItem.AllowCancel&&Detail.Type==1&&PackageBookInfo.HandleItem.CancelDate">可取消 </span>
                            <!-- <span v-if="PackageBookInfo.HandleItem.Stock>0">立即确认 </span>
                            未预约<span v-if="Detail.Type==2">随时退 </span>
                            过期未预约<span v-if="Detail.Type==2">全额退 </span> -->
                        </div>
                        
                        
                    </div>
                    <div class="total">
                        <p class="one"><span class="price">{{Currency}} <span> {{stock*PackageBookInfo.HandleItem.Price}}</span></span></p>
                    </div>
                </div>
            </div>
        </div>
        <Modal v-show="modal.show" :config="modal" @close="modal.show=false"></Modal>
        <!-- <BookReview v-if="bookReview.show" @ok="submit" @cancel="bookReview.show=false" :info="bookReviewInfo" :bookInfo="bookInfo"></BookReview> -->
	</div>

</template>
<script>
import Modal from "./../../common/cmpnt/Modal/modal.vue"; //跳转提示框
// import BookReview from './bookReview/bookReview.vue'//订单预览
import Loading from "./../../common/cmpnt/Loading/Loading.vue"; //缓冲
export default {
  name: "book",
  components: { Modal, Loading },
  data() {
    return {
      Detail: JSON.parse(this.dao.get("packageDetails")) || "",
      PackageBookInfo: JSON.parse(this.dao.get("packageBookInfo")) || "",
      stock: JSON.parse(this.dao.get("packageBookInfo")).MinCount || 1,
      Groups: [
        {
          CnName: "",
          CardNumber: "",
          NeedIDCard: JSON.parse(this.dao.get("packageBookInfo")).IsIdcard
        }
      ],
      Currency: this.dao.get("userInfo").Currency,
      Phone: this.dao.get("userInfo").Phone || "",
      SpecialRequest: "",
      isAgree: false,
      OrderNO: "",
      scroll: 32,
      //   MaxCount:''

      modal: {
        show: false,
        config: {}
      }
    };
  },
  methods: {
    minus() {
      if (this.stock == this.PackageBookInfo.MinCount) {
        this.error({ title: "提示", content: "已至最少购买数量" });
        return;
      }
      this.stock -= 1;
      if (this.Detail.Type == 1) {
        this.Groups.pop();
      }
    },
    //票数加1
    plus() {
      var guestItem = {
        CnName: "",
        CardNumber: "",
        NeedIDCard: JSON.parse(this.dao.get("packageBookInfo")).IsIdcard
      };
      if (this.Detail.Type == 1) {
        if (!this.PackageBookInfo.HandleItem.Status) {
          if (this.PackageBookInfo.HandleItem.IsAskRoom) {
            if (this.stock < this.PackageBookInfo.MaxCount && this.stock < 5) {
              this.stock += 1;
              this.Groups.push(guestItem);
            } else {
              this.error({ title: "提示", content: "已至最大购买数量" });
              return;
            }
          } else {
            if (
              this.stock < this.PackageBookInfo.MaxCount &&
              this.stock < this.PackageBookInfo.HandleItem.Stock &&
              this.stock < 5
            ) {
              this.stock += 1;
              this.Groups.push(guestItem);
            } else {
              this.error({ title: "提示", content: "已至最大购买数量" });
              return;
            }
          }
        }
      } else {
        if (
          this.stock < this.PackageBookInfo.MaxCount &&
          this.stock < this.PackageBookInfo.Stock &&
          this.stock < 5
        ) {
          this.stock += 1;
        } else {
          this.error({ title: "提示", content: "已至最大购买数量" });
          return;
        }
      }
    },

    isPhoneAvailable(phone) {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(phone)) {
        return false;
      } else {
        return true;
      }
    },

    checkBookAble() {
      var that = this;
      var data = that.Groups;
      var SFreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      var reg = new RegExp(
        "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      );
      for (let item = 0; item < data.length; item++) {
        if (that.PackageBookInfo.IsIdcard && that.Detail.Type == 1) {
          if (!(data[item].CnName && data[item].CardNumber)) {
            this.error({
              title: "提示",
              content: "您有未填写的信息，请继续填写"
            });
            return;
          } else if (!SFreg.test(data[item].CardNumber)) {
            this.error({
              title: "提示",
              content: "您的身份证格式有误，请您核对"
            });
            return;
          }
        } else if (that.Detail.Type == 1 && !that.PackageBookInfo.IsIdcard) {
          if (!data[item].CnName) {
            this.error({
              title: "提示",
              content: "您的姓名未填写，请继续填写"
            });
            return;
          }
        }

        if (!that.Phone) {
          this.error({ title: "提示", content: "您联系方式尚未填写" });
          return;
        } else if (!that.isPhoneAvailable(that.Phone)) {
          this.error({ title: "提示", content: "您的手机格式有误，请您核对" });
          return;
        }

        if (!that.isAgree) {
          this.error({ title: "提示", content: "请先同意预订规则！" });
          return;
        }
      }
      if (that.Detail.Type == 1) {
        var dateTime;
        if (that.PackageBookInfo.HandleItem.Date) {
          dateTime = new Date(that.PackageBookInfo.HandleItem.Date);
          dateTime = dateTime.setDate(dateTime.getDate() + 1);
          dateTime = new Date(dateTime);
          dateTime = that.dateToYMDline(dateTime);
        }
        that.modal = {
          show: true,
          content: "正在为您核对库存信息，请稍后...."
        };
        var param = {
          token:
            that.PackageBookInfo.Token || that.PackageBookInfo.HandleItem.Token,
          Count: that.stock,
          CheckIn: that.PackageBookInfo.HandleItem.Date || that.getDate(0),
          CheckOut: dateTime || that.getDate(1)
        };
        that
          .postRequest({
            url: that.Api.getPackageCheck,
            params: param
          })
          .then(res => {
            that.modal.show = false;
            if (res.IsSuccess) {
              that.PackageBookInfo.Count = that.stock;
              that.dao.set(
                "packageBookInfo",
                JSON.stringify(that.PackageBookInfo)
              );
              that.checkAccount();
            } else {
              that.error({ title: "提示", content: res.Msg || "不能预订" });
            }
          });
      } else {
        that.PackageBookInfo.Count = that.stock;
        that.dao.set("packageBookInfo", JSON.stringify(that.PackageBookInfo));
        that.checkAccount();
      }
    },
    //查询是否有额度，有的话直接下单，
    checkAccount() {
      var that = this;
      var params = {
        Token:
          that.PackageBookInfo.Token || that.PackageBookInfo.HandleItem.Token
      };
      that.modal = {
        show: true,
        content: "正在为您检查结算方式和信贷额度，请稍后.."
      };
      that
        .postRequest({
          url: that.Api.checkPackageAccount,
          params: params
        })
        .then(res => {
          that.modal.show = false;
          if (res && res.IsSuccess) {
            that.book(true);
          } else {
            that.book(false);
          }
        });
    },
    book(flag) {
      var that = this;
      var param = {
        Count: that.stock,
        Token:
          that.PackageBookInfo.Token || that.PackageBookInfo.HandleItem.Token,
        Guests: that.Groups,
        Phone: that.Phone,
        SpecialRequest: that.SpecialRequest,
        IsInvoice: false,
        Invoices: "",
        UseCreditAccount:flag
      };
      that.modal = {
        show: true,
        content: "正在为您提交订单，请稍后..."
      };
      that
        .postRequest({
          url: that.Api.getPackageCreate,
          params: JSON.stringify(param)
        })
        .then(res => {
          that.modal.show = false;
          if (res && res.IsSuccess) {
            that.OrderNO = res.Result.QGOrderNO;
            that.dao.set("thisBookingOrderNO", that.OrderNO);
            if (flag) {
              that.$router.push("/packageBookComplete?OrderNO=" + that.OrderNO);
            } else {
              var time = Date.parse(new Date())
              that.$router.push("/packageBookComfirm?OrderNO=" + that.OrderNO+'&time='+time);
            }
          } else if (!res.IsSuccess) {
            this.error({ title: "提示", content: res.Msg });
          }
        });
    },

    //返回详情页
    returnBack() {
      window.history.go(-1);
    },

    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      console.log(scrollTop)
      if (scrollTop > 155) {
        this.scroll = scrollTop - 123;
      } else if (scrollTop <= 155) {
        this.scroll = 32;
      }
    }
  },

  mounted() {
    var that = this
    window.addEventListener("scroll", this.handleScroll);
    that.$nextTick(() => {
      if(localStorage.getItem('lang')=='t'){
        that.$zh_tran(localStorage.getItem('lang'))
      }         
    })
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style scoped>
.compute {
  height: 30px;
  line-height: 30px;
}

.compute .btn {
  cursor: pointer;
  font-size: 15px;
  padding: 2px 10px;
  background-color: #f1f1f1;
}

.compute .count {
  padding: 0 10px;
}

.hotel-container .item-body {
  width: 60%;
}

.hotel-container .item-body .input-box {
  width: 300px;
}

.hotel-container .item-body textarea {
  width: 100%;
  height: 60px;
  resize: none;
  padding: 2px 10px 2px 0;
}

.main-container .main-left {
  float: none;
}

.hotel-container .main-left .title {
  margin: 20px 0;
}

.main-container .main-right {
  float: none;
  position: absolute;
  right: 0;
}

.hotel-container .main-right .room-name {
  font-size: 18px;
  font-weight: bold;
  margin: 20px 0;
}

.hotel-container .main-right .info {
  line-height: 1.7em;
}

.hotel-container .main-right .right-content > p {
  margin: 0;
  padding: 5px 0;
  font-size: 14px;
}

.hotel-container .main-right .tip {
  padding-top: 10px;
  padding-bottom: 20px;
}

.hotel-container .main-right .tip span {
  font-size: 12px;
  color: #fb8801;
  display: inline-block;
  padding: 3px 7px;
  background: #fff6eb;
  margin-right: 5px;
}

.hotel-container .main-right .total {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/package/book.vue